

export function toBrl(value: number | string): string {
    if (typeof value === 'string') {
        value = parseFloat(value.replace(/\./g, '').replace(',', '.'));
    }
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function isValidExpirationDate(val: string): boolean {
  const match = /^(\d{2})\/(\d{2})$/.exec(val);
  if (!match) return false;

  const month = Number(match[1]);
  const year = Number(match[2]);

  if (month < 1 || month > 12) return false;

  const now = new Date();
  const currentYear = now.getFullYear() % 100;
  const currentMonth = now.getMonth() + 1;

  return year > currentYear || (year === currentYear && month >= currentMonth);
}
/**
 * Normaliza um documento (CPF/CNPJ): remove formatação e mantém apenas
 * caracteres alfanuméricos em maiúsculas. Necessário para o CNPJ alfanumérico,
 * cujos 12 primeiros caracteres podem conter letras (A-Z).
 */
export function normalizeDocument(value: string): string {
    return value.toUpperCase().replace(/[^0-9A-Z]/g, '');
}

export function validateCpfCnpj(value: string): boolean {
    const doc = normalizeDocument(value);
    if (doc.length === 11) {
        return validateCpf(doc);
    } else if (doc.length === 14) {
        return validateCnpj(doc);
    }
    return false;
}

export function validateCpf(cpf: string): boolean {
    if (/^(\d)\1{10}$/.test(cpf)) return false; // all digits equal
    const numbers = cpf.split('').map(d => parseInt(d, 10));
    const calcCheckDigit = (slice: number[]) => {
        const sum = slice.reduce((acc, num, idx) => acc + num * (slice.length + 1 - idx), 0);
        const rev = 11 - (sum % 11);
        return rev > 9 ? 0 : rev;
    };
    const d1 = calcCheckDigit(numbers.slice(0, 9));
    const d2 = calcCheckDigit([...numbers.slice(0, 9), d1]);
    return d1 === numbers[9] && d2 === numbers[10];
}

export function validateCnpj(cnpj: string): boolean {
    const doc = normalizeDocument(cnpj);
    // CNPJ alfanumérico: 12 caracteres [0-9A-Z] + 2 dígitos verificadores numéricos
    if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(doc)) return false;
    if (/^([0-9A-Z])\1{13}$/.test(doc)) return false; // all chars equal
    // Valor de cálculo de cada caractere = código ASCII - 48 ('0'->0 ... 'A'->17 ... 'Z'->42)
    const values = doc.split('').map(c => c.charCodeAt(0) - 48);
    const calcCheckDigit = (slice: number[], weights: number[]) => {
        const sum = slice.reduce((acc, num, idx) => acc + num * weights[idx], 0);
        const rev = sum % 11;
        return rev < 2 ? 0 : 11 - rev;
    };
    const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const weights2 = [6, ...weights1];
    const d1 = calcCheckDigit(values.slice(0, 12), weights1);
    const d2 = calcCheckDigit([...values.slice(0, 12), d1], weights2);
    return d1 === values[12] && d2 === values[13];
}